import React from 'react';
import { Box, Typography, Paper, CircularProgress } from '@mui/material';

const PendingPage: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: '#f5f5f5',
        p: 3,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          textAlign: 'center',
          maxWidth: '500px',
          width: '100%',
        }}
      >
        <CircularProgress sx={{ mb: 2 }} />
        <Typography variant="h4" gutterBottom>
          Application Pending
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Thank you for submitting your application to join KalaKrut. Your request is currently under review by our team.
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mt: 2 }}>
          You will receive an email notification once your application has been approved. Please check your inbox (and spam folder) for an email from us with your login credentials.
        </Typography>
      </Paper>
    </Box>
  );
};

export default PendingPage;
